
export const EditButton = async ({id}: {
  id: number
}) => {
  return (
    <a href={`/api/edit?nid=${id}`} title="Edit content" className="flex">
      <span className="duration-300 transition-all w-0 overflow-hidden group-hover:w-10 block text-pink-600 group-hover:text-white group-hover:pl-2">Edit</span>
      <span className="after:bg-pink-600 group-hover:after:bg-white duration-300 transition-all overflow-hidden block after:!w-0 group-hover:after:!w-4 group-hover:mr-2 edit-icon"></span>
    </a>
  )
}